import LegalPage from "@/components/LegalPage";

export function CopyrightPage() {
  return <LegalPage titleKey="copyright.title" contentKey="copyright.content" />;
}